module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"WHITEPAPER":"WHITEPAPER","BONUSCLOUD":"BONUSCLOUD","detail":"The universally-carried fog computing platform in the world"},"zn":{"WHITEPAPER":"白皮书","BONUSCLOUD":"BONUSCLOUD","detail":"全球泛载雾计算平台"}}')
  delete Component.options._Ctor
}
